var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Sync") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Sync",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "7.33333333 28.3483333 7.33333333 22 13.6366667 22"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "24.6666667 3.66666667 24.6666667 10 18.3633333 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28,17.8483333 C4.55800396,12.944322 7.25654489,8.17582167 11.8323541,6.26989012 C16.4081634,4.36395856 21.6938847,5.80682699 24.6666667,9.77333333",
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.72,14.1666667 C27.443016,19.0710185 24.7448019,23.8404257 20.1686841,25.7468792 C15.5925662,27.6533327 10.3062199,26.2103681 7.33333333,22.2433333",
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.ecd70171788a125b1513863659adea02.svg";
export { ForwardRef as ReactComponent };